import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44435be5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = { class: "shop__header" }
const _hoisted_3 = { class: "shop__icons" }
const _hoisted_4 = { class: "shop__container" }
const _hoisted_5 = {
  key: 0,
  class: "shop__cards"
}
const _hoisted_6 = {
  key: 1,
  class: "shop-empty fallback"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shop-empty__label" }, "Nenhum produto foi encontrado.", -1))
const _hoisted_8 = {
  key: 0,
  class: "shop__pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_filter_shop = _resolveComponent("filter-shop")!
  const _component_card = _resolveComponent("card")!
  const _component_content_fallback = _resolveComponent("content-fallback")!
  const _component_PaginationDefault = _resolveComponent("PaginationDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("input", {
        type: "search",
        placeholder: "Buscar produto",
        "data-search": "",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchProduct($event.target.value))),
        class: "shop__search-input"
      }, null, 32),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { name: 'favorite' },
          class: "shop__favorite"
        }),
        _createVNode(_component_router_link, {
          class: "bag",
          to: { name: 'bag' }
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.bagProducts.length), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(_component_filter_shop, { filter: _ctx.filter }, null, 8, ["filter"]),
      (_ctx.products.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
              return (_openBlock(), _createBlock(_component_card, {
                key: index,
                product: product,
                user: _ctx.user
              }, null, 8, ["product", "user"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_content_fallback, null, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]))
    ]),
    (_ctx.products.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          _createVNode(_component_PaginationDefault, {
            "qt-pages": _ctx.pages,
            currentPage: _ctx.currentPage,
            onChangePage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentPage = $event))
          }, null, 8, ["qt-pages", "currentPage"])
        ]))
      : _createCommentVNode("", true)
  ]))
}